module.exports = __webpack_public_path__ + "img/layout_top.b2aded78.svg";